import { useEffect, useState } from "@wordpress/element";

export const useResponsiveZoom = (width: number): number => {
	const [zoom, setZoom] = useState(8.5);

	useEffect(() => {
		switch (true) {
			case width > 1300:
				setZoom(8.4);
				break;

			case width > 800:
				setZoom(8);
				break;

			case width > 420:
				setZoom(7.5);
				break;

			case width > 280:
				setZoom(7.2);
				break;

			default:
				setZoom(6);
		}
	}, [width]);

	return zoom;
};
